export default __webpack_public_path__ + "static/media/pantry2-after1-1440w.18c6272b.webp";